import script from "./SearchTopicInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchTopicInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchTopicInput.vue?vue&type=style&index=0&id=6612ab63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6612ab63"]])

export default __exports__